import { LegalEntitySourcesService_legalEntitySourcesServiceGetStops } from '@festina/legalentity-general-types/legalentity/hooks/LegalEntitySourcesStopsService_legalEntitySourcesServiceGetStops'

export const useFetchPersonStopHistory =
  LegalEntitySourcesService_legalEntitySourcesServiceGetStops.useQuery
